import { Formik, Form } from "formik";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  Autocomplete,
} from "@mui/material";
import { contactValidationSchema } from "../../utils/validations";

export const ContactForm = ({
  initialValues,
  onSubmit,
  companies,
  isSubmitting,
  submitLabel = "Add Contact",
  showActions = true,
  onCancel,
}) => {
  const defaultValues = {
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    phone: "",
  };

  return (
    <Formik
      initialValues={initialValues || defaultValues}
      validationSchema={contactValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting: formSubmitting,
      }) => (
        <Form>
          <TextField
            fullWidth
            name="firstName"
            placeholder="First Name *"
            value={values.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.firstName && Boolean(errors.firstName)}
            helperText={touched.firstName && errors.firstName}
            sx={{
              mb: 2,
              borderRadius: "12px",
              "& .MuiInputBase-root": {
                height: "44px",
                borderRadius: "12px",
              },
            }}
          />
          <TextField
            fullWidth
            name="lastName"
            placeholder="Last Name *"
            value={values.lastName}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.lastName && Boolean(errors.lastName)}
            helperText={touched.lastName && errors.lastName}
            sx={{
              mb: 2,
              borderRadius: "12px",
              "& .MuiInputBase-root": {
                height: "44px",
                borderRadius: "12px",
              },
            }}
          />
          <FormControl fullWidth sx={{ mb: 2 }}>
            <Autocomplete
              name="company"
              value={
                companies.find((company) => company.name === values.company) ||
                null
              }
              onChange={(event, newValue) => {
                handleChange({
                  target: {
                    name: "company",
                    value: newValue ? newValue.name : "",
                  },
                });
              }}
              options={companies}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.name === value}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Company"
                  error={Boolean(touched.company && errors.company)}
                  helperText={touched.company && errors.company}
                  sx={{
                    borderRadius: "12px",
                    "& .MuiInputBase-root": {
                      borderRadius: "12px",
                      height: "44px",
                    },
                  }}
                />
              )}
            />
          </FormControl>

          <TextField
            fullWidth
            name="email"
            placeholder="Email"
            type="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.email && Boolean(errors.email)}
            helperText={touched.email && errors.email}
            sx={{
              mb: 2,
              borderRadius: "12px",
              "& .MuiInputBase-root": {
                height: "44px",
                borderRadius: "12px",
              },
            }}
          />
          <TextField
            fullWidth
            name="phone"
            placeholder="Phone"
            value={values.phone}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.phone && Boolean(errors.phone)}
            helperText={touched.phone && errors.phone}
            sx={{
              borderRadius: "12px",
              "& .MuiInputBase-root": {
                height: "44px",
                borderRadius: "12px",
              },
            }}
          />

          {showActions && (
            <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
              {onCancel && (
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={onCancel}
                  disabled={isSubmitting || formSubmitting}
                >
                  Cancel
                </Button>
              )}
              <Button
                variant="contained"
                fullWidth
                type="submit"
                disabled={isSubmitting || formSubmitting}
                sx={{
                  bgcolor: "#6366f1",
                  borderRadius: "12px",
                  textTransform: "capitalize",
                }}
              >
                {isSubmitting || formSubmitting ? "Adding..." : submitLabel}
              </Button>
            </Box>
          )}
        </Form>
      )}
    </Formik>
  );
};
